import { LauncherApp } from '../models/launcher-app.model';
import { LauncherNotification } from '../models/launcher-notification.model';

export const LAUNCHER_APPS: LauncherApp[] = [
  {
    code: 'nfarm',
    name: 'Nova Farm',
    description: 'Gestione operativa delle aziende agricole e dei flussi collegati.',
    logoText: 'NF',
    licenseStatus: 'active',
    readOnly: false,
  }
  /*{
    code: 'ntrack',
    name: 'Nova Track',
    description: 'Monitoraggio attivita, esecuzioni e controlli sul campo.',
    logoText: 'NT',
    licenseStatus: 'activating',
    readOnly: true,
  },
  {
    code: 'ndelegate',
    name: 'Nova Delegate',
    description: 'Gestione deleghe, approvazioni e responsabilita operative.',
    logoText: 'ND',
    licenseStatus: 'expired',
    readOnly: true,
    renewLabel: 'Rinnova licenza',
  },*/
];

export const LAUNCHER_NOTIFICATIONS: LauncherNotification[] = [
  {
    id: 'pending-delegation',
    title: 'Delega in attesa',
    message: 'lorem ipsum dolor sit amet',
    tone: 'warning',
    icon: 'pi pi-users',
  },
  {
    id: 'expiring-license',
    title: 'Avvisi e scadenze',
    message: 'lorem ipsum dolor sit amet',
    tone: 'info',
    icon: 'pi pi-bell',
  },
];
